import Request from "../../utils/Request";
import {AxiosResponse} from "axios";

/**
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
const DownloadAllApiUpload = (data: any[] = {}): Promise<AxiosResponse<any>> =>
	Request.get(`/advisors/download-all-api-upload/${data}`);

export default DownloadAllApiUpload;